import { render, staticRenderFns } from "./Audit-List.vue?vue&type=template&id=438392f2&scoped=true&"
import script from "./Audit-List.vue?vue&type=script&lang=js&"
export * from "./Audit-List.vue?vue&type=script&lang=js&"
import style0 from "../CGC.scss?vue&type=style&index=0&id=438392f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438392f2",
  null
  
)

export default component.exports